'use strict';
/** @typedef {import('./generated-types').ConstantNumberMap} ConstantNumberMap */

var _slicedToArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('./base-table'),
    baseTable = _require.baseTable;

var constants =
/** @type {ConstantNumberMap} */
{};

for (var _i = 0, _Object$entries = Object.entries(baseTable); _i < _Object$entries.length; _i++) {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      name = _Object$entries$_i[0],
      code = _Object$entries$_i[1];

  var constant = name.toUpperCase().replace(/-/g, '_');
  constants[constant] = code;
}

module.exports = Object.freeze(constants);